import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { useTheme } from '../../../../../theming/useTheme';
import { VrLineHeight } from '../../../../../theming/verticalRhythm/verticalRhythm';
import { footerSectionPadding } from '../footer.utils';
import { TextLinkComponent } from '../../../../partials/link/TextLink';
import { ErrorBoundary } from '../../../../errorHandling/ErrorBoundary';
import { MEDIA_BREAKPOINTS } from '../../../../../mediaQueries.const';
import { H4, semanticCSS } from '../../../../../typography/semanticTags';

const componentConfigurationKey = 'footerMobileStores';

interface StoreLink {
  href: string
  src: string
  alt: string
}

export interface FooterMobileStoresBaseProps {
  title: string
  imageLinks: StoreLink[]
}

interface MobileStoresThemeProps {
  vrLineHeight: VrLineHeight
  color: string
}

const getStyle = (theme: MobileStoresThemeProps, numColumns: number = 2) => {
  const { vrLineHeight } = theme;
  const padding = footerSectionPadding(vrLineHeight);
  const columns = Array(numColumns).fill('auto').join(' ');

  return StyleSheet.create({
    section: {
      ...padding,
    },
    title: {
      textAlign: 'center',
      color: theme.color,
    },
    storesWrapper: {
      display: 'grid',
      gridTemplateColumns: columns,
      justifyContent: 'center',
      [MEDIA_BREAKPOINTS.LARGE]: {
        gridGap: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 0.5}px`,
        marginTop: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        gridGap: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5}px`,
        marginTop: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        gridGap: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5}px`,
        marginTop: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5}px`,
      },
    },
    storeItem: {
      backgroundColor: 'wheat',
    },
  });
};

const createStoreItem = (storeLink: StoreLink, index: number) => {
  return (
    <TextLinkComponent href={storeLink.href} key={index} target="_blank">
      <img alt={storeLink.alt} src={storeLink.src} height="40" />
    </TextLinkComponent>
  );
};

export const FooterMobileStoresComponent = (props: MobileStoresThemeProps & FooterMobileStoresBaseProps) => {
  const { title, imageLinks } = props;
  const style = getStyle(props, imageLinks.length);
  return (
    <div className={css(style.section)}>
      <H4 styles={semanticCSS(style.title)}>{title}</H4>
      <div className={css(style.storesWrapper)}>
        {
          imageLinks.map(createStoreItem)
        }
      </div>
    </div>
  );
};

const mapThemeProps = (theme: MobileStoresThemeProps) => ({
  vrLineHeight: theme.vrLineHeight,
  color: theme.color,
});

export const FooterMobileStores = (props: FooterMobileStoresBaseProps) => {
  const themeContext = useTheme(mapThemeProps, componentConfigurationKey);
  return <ErrorBoundary><FooterMobileStoresComponent {...themeContext} {...props} /></ErrorBoundary>;
};
